import { compose, withHandlers, defaultProps } from 'recompose';
import { noop } from 'lodash';

import setWrappedDisplayName from 'decorators/setWrappedDisplayName';
import { setLocation } from 'lib/helpers';
import {
	trackContactLinkClick,
	trackOutboundLinkClick,
} from './clickTrackingUtils';

const enhance = compose(
	defaultProps({
		onClick: noop,
	}),
	withHandlers({
		handleClick:
			({ onClick, href, target }) =>
			(evt) => {
				// If coreButton, coreLink components that stay within the site
				if (href && target !== '_blank') {
					evt.preventDefault(evt);
					setLocation(href);

					const isTelTag = href.includes('tel:');
					const isMailTag = href.includes('mailto:');

					// If the link or button leads to a number/email
					if (isTelTag || isMailTag) {
						const { target } = evt;
						const { id, className, innerText } = target;

						let tagType = isTelTag ? 'tel' : 'mailto';

						trackContactLinkClick(
							id || className,
							innerText,
							innerText,
							tagType
						);
					}
				}

				// if the coreLink/coreButton leads to an external site
				else if (href && target.includes('blank')) {
					const { target } = evt;
					const { id, innerText } = target;

					trackOutboundLinkClick(
						id || 'outbound-link',
						innerText,
						innerText,
						href
					);
				}

				Promise.resolve(onClick(evt));
			},
	}),
	setWrappedDisplayName('SegmentClickTracking')
);

export default enhance;
